/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterstext
 */
import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Text" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersText ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersText extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Text', [
            {
                character: '\u2039',
                title: t('q')
            },
            {
                character: '\u203A',
                title: t('r')
            },
            {
                character: '\xAB',
                title: t('s')
            },
            {
                character: '\xBB',
                title: t('t')
            },
            {
                character: '\u2018',
                title: t('u')
            },
            {
                character: '\u2019',
                title: t('v')
            },
            {
                character: '\u201C',
                title: t('w')
            },
            {
                character: '\u201D',
                title: t('x')
            },
            {
                character: '\u201A',
                title: t('y')
            },
            {
                character: '\u201E',
                title: t('z')
            },
            {
                character: '\xA1',
                title: t('aa')
            },
            {
                character: '\xBF',
                title: t('ab')
            },
            {
                character: '\u2025',
                title: t('ac')
            },
            {
                character: '\u2026',
                title: t('ad')
            },
            {
                character: '\u2021',
                title: t('ae')
            },
            {
                character: '\u2030',
                title: t('af')
            },
            {
                character: '\u2031',
                title: t('ag')
            },
            {
                character: '\u203C',
                title: t('ah')
            },
            {
                character: '\u2048',
                title: t('ai')
            },
            {
                character: '\u2049',
                title: t('aj')
            },
            {
                character: '\u2047',
                title: t('ak')
            },
            {
                character: '\xA9',
                title: t('al')
            },
            {
                character: '\xAE',
                title: t('am')
            },
            {
                character: '\u2122',
                title: t('an')
            },
            {
                character: '\xA7',
                title: t('ao')
            },
            {
                character: '\xB6',
                title: t('ap')
            },
            {
                character: '\u204B',
                title: t('aq')
            }
        ]);
    }
}